import type { Game } from 'chessboard/model/game/types';
import type { Board } from 'chessboard/model/board/types';
import type { API } from 'api/config/types';

/**
 * Should drop piece and return to idle state
 */
export function shouldDropOrDeselectPiece({
  api,
  move,
  plyDiff,
  pieceSquare,
}: {
  api: API.ExtendedAPI;
  move: Game.Move.Node | undefined;
  plyDiff: number | undefined;
  pieceSquare: Board.SanSquare | undefined;
}): boolean {
  const pieceColor = pieceSquare && api.getPieces().getCollection()[pieceSquare]?.color;

  // Piece should be dropped if we have no move object, it's not our turn, or if the move wasn't user generated
  if (!move || plyDiff !== 1 || !pieceColor || (pieceColor === move.color && !move.userGenerated)) {
    return true;
  }

  return move.from === pieceSquare || move.to === pieceSquare;
}
